import { useContext, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { AccountContext } from '../useContext/Account';
import logo from '../imagenes/logo-marca.png';

/* Ingreso al sistema: panel de marca (izquierda) + formulario (derecha).
   Estilos en src/tema/tema-corporativo.css (.sym-login). */
function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [cargando, setCargando] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [verClave, setVerClave] = useState(false);
  const [mayus, setMayus] = useState(false);

  const { authenticate } = useContext(AccountContext);

  const onSubmit = (e) => {
    e.preventDefault();
    setErrorMsg('');
    if (!username.trim() || !password) {
      setErrorMsg('Por favor ingrese su usuario y clave.');
      return;
    }
    setCargando(true);
    authenticate(username.trim(), password)
      .then(() => {
        toast.success('Ingreso exitoso');
        window.location.href = '/Dashboard';
      })
      .catch(() => {
        setErrorMsg('Usuario o clave incorrectos. Por favor intente nuevamente.');
        setCargando(false);
      });
  };

  const revisarMayus = (e) => setMayus(!!(e.getModifierState && e.getModifierState('CapsLock')));

  return (
    <div className="sym-login">

      <aside className="sym-login__marca">
        <img src={logo} alt="Laboratorio Rey-Fals" className="sym-login__logo" />
        <div className="sym-login__lema">
          <h1>Symedic</h1>
          <p>Sistema de gestión de laboratorio clínico</p>
          <ul>
            <li>Órdenes, resultados y firma en un solo lugar</li>
            <li>Facturación, cartera y RIPS</li>
            <li>Trabaje con el teclado: <kbd className="sym-kbd sym-kbd--oscuro">Ctrl K</kbd> lo lleva a cualquier pantalla</li>
          </ul>
        </div>
        <small>© {new Date().getFullYear()} Symedic · Todos los derechos reservados</small>
      </aside>

      <main className="sym-login__panel">
        <ToastContainer />
        <form className="sym-login__form" onSubmit={onSubmit} noValidate>
          <h2>Ingresar</h2>
          <p className="sym-login__sub">Use el usuario y la clave asignados por el laboratorio.</p>

          {errorMsg && <div className="alert alert-danger py-2" role="alert">{errorMsg}</div>}

          <div className="mb-3">
            <label className="form-label" htmlFor="login-user">Usuario</label>
            <input
              id="login-user"
              className="form-control form-control-lg"
              type="text"
              placeholder="Su usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              onKeyUp={revisarMayus}
            />
          </div>

          <div className="mb-2">
            <label className="form-label" htmlFor="login-pass">Clave</label>
            <div className="sym-login__clave">
              <input
                id="login-pass"
                className="form-control form-control-lg"
                type={verClave ? 'text' : 'password'}
                placeholder="Su clave"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                onKeyUp={revisarMayus}
              />
              <button
                type="button"
                className="sym-login__ojo"
                onClick={() => setVerClave((v) => !v)}
                aria-label={verClave ? 'Ocultar clave' : 'Mostrar clave'}
                title={verClave ? 'Ocultar clave' : 'Mostrar clave'}
                tabIndex={-1}
              >
                {verClave ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a20.3 20.3 0 0 1 5.06-6.06M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a20.32 20.32 0 0 1-3.22 4.5M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>
          <div className="sym-login__aviso" aria-live="polite">{mayus ? 'Las mayúsculas están activadas' : ''}</div>

          <button type="submit" className="btn btn-primary btn-lg w-100 mt-2" disabled={cargando}>
            {cargando ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Ingresando…
              </>
            ) : (
              'Ingresar'
            )}
          </button>
          <p className="sym-login__pie">¿Olvidó su clave? Comuníquese con el administrador del sistema.</p>
        </form>
      </main>
    </div>
  );
}

export default Login;
